export function areAdsBlocked() {
    const testAd = document.querySelector('[ad-for-detector]');

    if (!testAd) {
        return false;
    }

    try {
        return getComputedStyle(testAd)?.display === 'none';
    } catch (_error) {
        return false;
    }
}

export function createFakeAdForAdBlockDetection() {
    const fakeAd = document.createElement('div');

    fakeAd.setAttribute('ad-for-detector', '');
    fakeAd.setAttribute('id', 'GlobalCookieBanner');
    fakeAd.classList.add('subscribe_box');
    fakeAd.classList.add('ad-box');
    fakeAd.classList.add('netboard');
    fakeAd.classList.add('advert');
    fakeAd.classList.add('module');
    fakeAd.classList.add('banner');
    fakeAd.classList.add('leaderboard');
    fakeAd.classList.add('advertisement');
    fakeAd.style.opacity = '0';
    fakeAd.style.width = '0px';
    fakeAd.style.height = '0px';
    fakeAd.style.minWidth = '0px';
    fakeAd.style.minHeight = '0px';
    fakeAd.style.maxWidth = '0px';
    fakeAd.style.maxHeight = '0px';
    fakeAd.style.position = 'absolute';
    fakeAd.style.boxSizing = 'border-box';
    fakeAd.style.margin = '0';

    document.body.appendChild(fakeAd);
}
